import Icon from '../components/Icon.vue'

Icon.register({"long-arrow-alt-right":{"width":448,"height":512,"paths":[{"d":"M313.9 216H12C5.4 216 0 221.4 0 228V284C0 290.6 5.4 296 12 296H313.9V342.1C313.9 363.4 339.8 374.1 354.9 359L441 273C450.3 263.6 450.3 248.4 441 239L354.9 153C339.8 137.9 313.9 148.6 313.9 169.9V216z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/long-arrow-alt-right.js